module.exports = __webpack_public_path__ + "img/create_note.71ba81bc.svg";